import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

export const actionTypes = {
  getAllTownships: "[getAllTownships] Action",
  getAllTownshipsGroup: "[getAllTownshipsGroup] Action",
  getAllTravels: "[getAllTravels] Action",
  destination: "[destination] Action",
  source: "[source] Action",
  departuredDate: "[departuredDate] Action",
  returnDate: "[returnDate] Action",
  isSimple: "[isSimple] Action",
  bigCount: "[bigCount] Action",
  smallCount: "[smallCount] Action",
  destId: "[destId] Action",
  srcId: "[srcId] Action",
  srcAndDestTitle: "[srcAndDestId] Action",
  currentClassName: "[currentClassName] Action",
};

const initialCountreiesState = {
  townships: [],
  travels: [],
  destination: undefined,
  source: undefined,
  departuredDate: undefined,
  returnDate: undefined,
  isSimple: undefined,
  bigCount: 1,
  smallCount: 0,
  destId: undefined,
  srcId: undefined,
  srcAndDestTitle: undefined,
  currentClassName: undefined,
};

export const reducer = persistReducer(
  { storage, key: "v705-demo1-auth", whitelist: ["user", "cars"] },
  (state = initialCountreiesState, action) => {
    switch (action.type) {
      case actionTypes.getAllTownships: {
        const townships = action.payload;
        return { ...state, townships };
      }
      case actionTypes.getAllTownshipsGroup: {
        const townships = action.payload;
        return { ...state, townships };
      }
      case actionTypes.currentClassName: {
        return { ...state, currentClassName: action.payload };
      }

      case actionTypes.getAllTravels: {
        const travels = action.payload;
        return { ...state, travels };
      }
      case actionTypes.srcAndDestTitle: {
        const srcAndDestTitle = action.payload;
        return { ...state, srcAndDestTitle };
      }
      case actionTypes.destId: {
        const destId = action.payload;
        return { ...state, destId };
      }
      case actionTypes.srcId: {
        const srcId = action.payload;
        return { ...state, srcId };
      }
      case actionTypes.destination: {
        const destination = action.payload;
        return { ...state, destination };
      }
      case actionTypes.source: {
        const source = action.payload;
        return { ...state, source };
      }
      case actionTypes.departuredDate: {
        const departuredDate = action.payload;
        return { ...state, departuredDate };
      }
      case actionTypes.returnDate: {
        const returnDate = action.payload;
        return { ...state, returnDate };
      }
      case actionTypes.isSimple: {
        const isSimple = action.payload;
        return { ...state, isSimple };
      }
      case actionTypes.bigCount: {
        const bigCount = action.payload;
        return { ...state, bigCount };
      }
      case actionTypes.smallCount: {
        const smallCount = action.payload;
        return { ...state, smallCount };
      }
      default:
        return state;
    }
  }
);

export const actions = {
  getAllTownships: (payload) => ({
    type: actionTypes.getAllTownships,
    payload,
  }),
  getAllTownshipsGroup: (payload) => ({
    type: actionTypes.getAllTownshipsGroup,
    payload,
  }),
  getAllTravels: (payload) => ({
    type: actionTypes.getAllTravels,
    payload,
  }),
  destination: (payload) => ({
    type: actionTypes.destination,
    payload,
  }),
  source: (payload) => ({
    type: actionTypes.source,
    payload,
  }),
  departuredDate: (payload) => ({
    type: actionTypes.departuredDate,
    payload,
  }),
  returnDate: (payload) => ({
    type: actionTypes.returnDate,
    payload,
  }),
  isSimple: (payload) => ({
    type: actionTypes.isSimple,
    payload,
  }),
  bigCount: (payload) => ({
    type: actionTypes.bigCount,
    payload,
  }),
  smallCount: (payload) => ({
    type: actionTypes.smallCount,
    payload,
  }),
  setSrcId: (payload) => ({
    type: actionTypes.srcId,
    payload,
  }),
  setDestId: (payload) => ({
    type: actionTypes.destId,
    payload,
  }),
  setSrcAndDestTitle: (payload) => ({
    type: actionTypes.srcAndDestTitle,
    payload,
  }),
  setCurrentClassName: (payload) => ({
    type: actionTypes.currentClassName,
    payload,
  }),
};
